import Tooltip, { tooltipClasses, type TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { mergeSlotProps } from '@mui/material/utils';
import { usePopupZIndex } from '@components/Modal/popupLayer';

const LayeredTooltip = ({ className, slotProps, ...props }: TooltipProps) => {
    const popupZIndex = usePopupZIndex();

    return (
        <Tooltip
            {...props}
            classes={{ popper: className }}
            slotProps={{ ...slotProps, popper: mergeSlotProps(slotProps?.popper, { style: { zIndex: popupZIndex } }) }}
        />
    );
};

const CssTooltip = styled(LayeredTooltip)(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'var(--text-primary)',
        fontSize: '12px',
        lineHeight: '14px',
        letterSpacing: '0.4px',
        fontFamily: 'Rubik',
        padding: '5px 8px',
    },
}));

export default CssTooltip;
